import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useTranslation } from "react-i18next";

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-paper">
      <Navbar />
      <main className="pt-24 md:pt-32 pb-20">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-2xl mx-auto">
            <div className="text-center mb-12">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold mb-4">
                {t("contact.sectionLabel")}
              </p>
              <h1 className="font-serif text-4xl md:text-5xl font-semibold text-ink mb-6">
                {t("contact.title")}
              </h1>
              <p className="text-lg text-ink/50 font-light">
                {t("contact.intro")}
              </p>
            </div>

            {submitted ? (
              <div className="bg-white p-10 md:p-12 border border-hairline text-center">
                <div className="w-16 h-16 bg-gold/10 flex items-center justify-center mx-auto mb-6">
                  <i className="ri-check-line text-2xl text-gold"></i>
                </div>
                <h2 className="font-serif text-2xl font-semibold text-ink mb-3">
                  {t("misc.thankYou")}
                </h2>
                <p className="text-ink/50 font-light">
                  {t("misc.receivedInquiry")}
                </p>
              </div>
            ) : (
              <form
                action="https://readdy.ai/api/form/d86n54io8uvplcbvqeo0"
                method="POST"
                data-readdy-form
                id="noren-inquiry"
                onSubmit={() => setSubmitted(true)}
                className="bg-white p-6 md:p-10 border border-hairline"
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
                  <div>
                    <label className="block text-sm font-medium text-ink mb-2">{t("contact.firstName")}</label>
                    <input type="text" name="firstName" required
                      className="w-full px-4 py-3 border border-hairline bg-paper text-ink text-sm focus:outline-none focus:border-gold transition-colors duration-300"
                      placeholder="James" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-ink mb-2">{t("contact.lastName")}</label>
                    <input type="text" name="lastName" required
                      className="w-full px-4 py-3 border border-hairline bg-paper text-ink text-sm focus:outline-none focus:border-gold transition-colors duration-300"
                      placeholder="Chen" />
                  </div>
                </div>
                <div className="mb-5">
                  <label className="block text-sm font-medium text-ink mb-2">{t("contact.email")}</label>
                  <input type="email" name="email" required
                    className="w-full px-4 py-3 border border-hairline bg-paper text-ink text-sm focus:outline-none focus:border-gold transition-colors duration-300"
                    placeholder="james@example.com" />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
                  <div>
                    <label className="block text-sm font-medium text-ink mb-2">{t("contact.country")}</label>
                    <select name="country" required
                      className="w-full px-4 py-3 border border-hairline bg-paper text-ink text-sm focus:outline-none focus:border-gold transition-colors duration-300">
                      <option value="">{t("option.select")}</option>
                      <option value="US">{t("option.us")}</option>
                      <option value="UK">{t("option.uk")}</option>
                      <option value="CA">{t("option.ca")}</option>
                      <option value="AU">{t("option.au")}</option>
                      <option value="SG">{t("option.sg")}</option>
                      <option value="HK">{t("option.hk")}</option>
                      <option value="Other">{t("option.other")}</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-ink mb-2">{t("contact.budget")}</label>
                    <select name="budget" required
                      className="w-full px-4 py-3 border border-hairline bg-paper text-ink text-sm focus:outline-none focus:border-gold transition-colors duration-300">
                      <option value="">{t("option.select")}</option>
                      <option value="under-1m">{t("option.under1m")}</option>
                      <option value="1m-5m">{t("option.1mTo5m")}</option>
                      <option value="5m-10m">{t("option.5mTo10m")}</option>
                      <option value="10m-20m">{t("option.10mTo30m")}</option>
                      <option value="over-20m">{t("option.over20m")}</option>
                    </select>
                  </div>
                </div>
                <div className="mb-5">
                  <label className="block text-sm font-medium text-ink mb-2">{t("contact.goal")}</label>
                  <select name="goal" required
                    className="w-full px-4 py-3 border border-hairline bg-paper text-ink text-sm focus:outline-none focus:border-gold transition-colors duration-300">
                    <option value="">{t("option.select")}</option>
                    <option value="rental-income">{t("option.rentalIncome")}</option>
                    <option value="personal-use">{t("option.personalUse")}</option>
                    <option value="retirement">{t("option.retirement")}</option>
                    <option value="portfolio">{t("option.portfolio")}</option>
                    <option value="exploring">{t("option.exploring")}</option>
                  </select>
                </div>
                <div className="mb-6">
                  <label className="block text-sm font-medium text-ink mb-2">{t("contact.message")}</label>
                  <textarea name="message" rows={4} maxLength={500}
                    className="w-full px-4 py-3 border border-hairline bg-paper text-ink text-sm focus:outline-none focus:border-gold transition-colors duration-300 resize-none"
                    placeholder={t("contact.messagePlaceholder")}></textarea>
                  <p className="text-xs text-ink/30 mt-1 font-light">{t("label.maxChars")}</p>
                </div>
                <button type="submit"
                  className="w-full inline-flex items-center justify-center gap-2 bg-ink text-paper text-sm font-medium px-6 py-3.5 rounded-full hover:bg-indigo transition-colors duration-300 whitespace-nowrap">
                  {t("btn.submit")}
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </button>
                <p className="text-xs text-ink/30 text-center mt-5 font-light">{t("contact.privacy")}</p>
              </form>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}